<script>
import { mapGetters } from "vuex";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import Stat from "./widget";
// import RevenueAnalytics from "./revenue";
// import SalesAnalytics from "./sales-analytics";
// import EarningReport from "./earning";
// import Sources from "./sources";
import RecentEssays from "./recent-essays";
import EssaysByStatus from "./essays-by-status";
import AppBrandLogo from "@/components/AppBrandLogo.vue";
// import Chat from "./chat";
// import Transaction from './transaction';

/**
 * Dashboard component
 */
export default {
  components: {
    Layout,
    PageHeader,
    Stat,
    // RevenueAnalytics,
    // SalesAnalytics,
    // EarningReport,
    // Sources,
    RecentEssays,
    EssaysByStatus,
    AppBrandLogo,
    // Chat,
    // Transaction
  },
  data() {
    return {
      title: "Home",
      items: [
        {
          text: "CEX"
        },
        {
          text: "Dashboard",
          active: true
        }
      ]
    };
  },
  computed: {
    ...mapGetters("auth", ["role"]),
    /** Role id 1: full dashboard widgets (same convention as route guards). */
    showDashboardStats() {
      return this.role != null && Number(this.role.id) === 1;
    },
  },
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :title="title" :items="items" /> -->
    <PageHeader :title="title" />

    <template v-if="showDashboardStats">
      <div class="row">
        <div class="col-xl-8">
          <Stat />
          <EssaysByStatus />
        </div>
        <div class="col-xl-4">
          <RecentEssays />
        </div>
      </div>
    </template>

    <div
      v-else
      class="row justify-content-center align-items-center"
      style="height: 50vh;"
    >
      <div class="col-4 text-center">
        <AppBrandLogo class-name="img-fluid" />
      </div>
    </div>
  </Layout>
</template>